import { createContractor } from './mutations/createContractor';
import { selfOnboarding } from './mutations/selfOnboarding';
import { createDraftEmployee } from './mutations/createDraftEmployee';
import { updateDraftEmployeeBasicsStep } from './mutations/updateDraftEmployeeBasicsStep';
import { updateDraftEmployeeCompensationStep } from './mutations/updateDraftEmployeeCompensationStep';
import { updateDraftEmployeeComplianceStep } from './mutations/updateDraftEmployeeComplianceStep';
import { deleteDraftEmployee } from './mutations/deleteDraftEmployee';
import { createEmployee } from './mutations/createEmployee';
import { getSelfOnboardingData } from './queries/getSelfOnboardingData';
import { getDraftEmployee } from './queries/getDraftEmployee';
import { getPeopleListSummary } from './queries/getPeopleListSummary';
import { getPeopleList } from './queries/getPeopleList';
import { getDraftEmployeeList } from './queries/getDraftEmployeeList';

const mutations = {
  createContractor,
  selfOnboarding,
  createDraftEmployee,
  updateDraftEmployeeBasicsStep,
  updateDraftEmployeeCompensationStep,
  updateDraftEmployeeComplianceStep,
  deleteDraftEmployee,
  createEmployee,
};

const queries = {
  getSelfOnboardingData,
  getDraftEmployee,
  getPeopleListSummary,
  getPeopleList,
  getDraftEmployeeList,
};

const exports = {
  mutations,
  queries,
};

export default exports;
